import { intl } from '@beelday/common'
import { FC } from 'react'
import { speakersNeedAttention } from './model/speakers'
import { PresenterSettings } from './presentation/presenter-settings'
import { SpeakersPicker } from './presentation/speakers-picker'
import { usePopover } from './use-popover'
import { useSpeakersControls } from './use-speakers-controls'

/**
 * The presenter panel's settings: the gear, and in its box the speaker
 * picker. The gear carries the warning while the chosen speakers are
 * unavailable, so the trainer sees it without opening the box.
 */
export const ConfiguredPresenterSettings: FC = () => {
	const translate = intl.useTranslate()
	const speakers = useSpeakersControls()
	const popover = usePopover()

	if (!speakers) {
		return null
	}
	return (
		<PresenterSettings
			open={popover.open}
			onToggle={popover.toggle}
			triggerRef={popover.triggerRef}
			boxRef={popover.boxRef}
			attention={
				speakersNeedAttention(speakers.view)
					? translate('in_person.presenter.speakers.unavailable')
					: null
			}
		>
			<SpeakersPicker
				view={speakers.view}
				onChoose={speakers.onChoose}
				onRevealNames={speakers.onRevealNames}
			/>
		</PresenterSettings>
	)
}

export default ConfiguredPresenterSettings
